module.exports = __webpack_public_path__ + "img/user-avatar-bg.c1ef45c.jpg";